import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Step1 } from '../../../../shared/models/component-messages/simp_in/step1';
import { Non } from '../models/Non';
@Component({
	selector: 'app-non',
	templateUrl: './non.component.html'
})
export class NonComponent implements OnInit {
	@Input() uid = '';
	public current_uid = 'Non';
	@Input() parentForm: FormGroup;
	
	@Input() disabled: boolean;
	@Input() non: Non;

	public step1 = new Step1();

	constructor() {}

	public ngOnInit() {}

	getUid() {
		return this.uid + '_SepSep_' + this.current_uid;
	}
}
